import type { Workspaces, DirectStore } from '@/modules/shared/types'

export type OrgLandingTarget =
  | { to: '/welcome' }
  | { to: '/select' }
  | { to: '/$orgSlug/overview'; params: { orgSlug: string } }
  | { to: '/$orgSlug/$clientSlug'; params: { orgSlug: string; clientSlug: string } }

/**
 * Direct stores worth showing in the chooser: a store already reachable
 * through a listed agency membership is deduped away (the agency path wins).
 */
export function chooserDirectStores(ws: Workspaces): DirectStore[] {
  const memberOrgSlugs = new Set(ws.organizations.map((o) => o.slug))
  return ws.directStores.filter((s) => !memberOrgSlugs.has(s.orgSlug))
}

/**
 * Where an authenticated user lands. Unambiguous destinations skip the
 * chooser; anything else goes to /select. No memberships -> /welcome.
 */
export function orgLandingTarget(ws: Workspaces): OrgLandingTarget {
  const orgs = ws.organizations
  const stores = chooserDirectStores(ws)
  const firstOrg = orgs[0]
  const firstStore = stores[0]

  if (!firstOrg && !firstStore) return { to: '/welcome' }
  if (orgs.length === 1 && stores.length === 0 && firstOrg) {
    return { to: '/$orgSlug/overview', params: { orgSlug: firstOrg.slug } }
  }
  if (orgs.length === 0 && stores.length === 1 && firstStore) {
    return {
      to: '/$orgSlug/$clientSlug',
      params: { orgSlug: firstStore.orgSlug, clientSlug: firstStore.slug },
    }
  }
  return { to: '/select' }
}
